module.exports = __webpack_public_path__ + "static/media/conner-logo.772ab8e5.png";